import { hashKeys } from "@coworker/app/src/components/RoomSettings/tools";
import { INTERVAL } from "@coworker/app/src/constants/clientTime";
import { httpClient } from "@coworker/http-client";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { ItemType } from "../../constants/itemType";
import { ItemStockInfo } from "./useItemStock";

const STALE_TIME = INTERVAL.HOUR * 3; // 3 hours

export type ItemsStock = Record<string, ItemStockInfo>;
type BulkItemStockResponse = {
  itemsStock: ItemsStock;
};
async function getBulkItemStock(filteredItems: string[]): Promise<ItemsStock> {
  const queryString = filteredItems.map((item) => `item=${item}`).join("&");
  const data = await httpClient.tasks.get<BulkItemStockResponse>(
    `/items/items-stock?${queryString}`
  );
  return data.itemsStock ?? {};
}

const getItemType = (item: string) => item.split(":")[1];

export function useItemsStock(items: string[]) {
  // Cannot be sent SCI: this is a composite article consisting of multiple sub-articles,
  // each with its own stock information, which is not supported by the service.
  const filteredItems = useMemo(
    () =>
      items.filter((item) => ItemType.LOCAL_COMBINATION !== getItemType(item)),
    [items]
  );

  return useQuery({
    queryKey: ["item", "stock", "bulk", hashKeys(filteredItems)],
    queryFn: () => getBulkItemStock(filteredItems),
    staleTime: STALE_TIME,
    gcTime: STALE_TIME,
    enabled: filteredItems.length > 0,
  });
}
